import { GRAMMAR_MASTERY_STATES } from '@repo/config';
import { z } from 'zod';

export const listeningUserStateSchema = z.object({
  challengeId: z.number().int().positive(),
  level: z.number().int().nonnegative(),
  nextReviewAt: z.number().int().nonnegative(),
  mastery: z.enum(GRAMMAR_MASTERY_STATES),
  lapses: z.number().int().nonnegative(),
  passed: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
  recentClipIds: z.array(z.number().int().positive()),
  lastReviewedAt: z.number().int().nonnegative(),
});

export type IListeningUserState = z.infer<typeof listeningUserStateSchema>;
